import {useEffect, useState} from 'react'
import axios from 'axios'
import {API_ENDPOINTS} from '../../../../constants/apiConstants'
import {Elements} from '@stripe/react-stripe-js'
import {FaCheckCircle, FaTrash, FaStar} from 'react-icons/fa'
import {toast} from 'react-toastify'
import {stripePromise} from '../../helper'
import AddCardForm from '../../components/stripe-payments/AddCardForm'
import ConfirmationModal from '../../components/modals/ConfirmationModal'

export default function ManageCards() {
  const [cards, setCards] = useState([])
  const [defaultPM, setDefaultPM] = useState('')
  const [addingCard, setAddingCard] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [deleteCardId, setDeleteCardId] = useState(false)
  // const [isLoading, setIsLoading] = useState(false)
  const [isActionLoading, setIsActionLoading] = useState(false)

  const fetchCards = async () => {
    // setIsLoading(true)
    try {
      const res = await axios.get(API_ENDPOINTS.GET_PAYMENT_METHODS())
      setCards(res?.data?.data || [])
    } catch (error) {
      toast.error('Failed to fetch cards')
    } finally {
      // setIsLoading(false)
    }
  }

  const fetchDefaultPM = async () => {
    try {
      const res = await axios.get(API_ENDPOINTS.GET_DEFAULT_PAYMENT_METHOD())
      setDefaultPM(res.data.data?.default_payment_method)
    } catch {
      toast.error('Failed to fetch default payment method')
    }
  }

  useEffect(() => {
    fetchCards()
    fetchDefaultPM()
  }, [])

  const handleSetDefault = async (id) => {
    setIsActionLoading(true)
    try {
      await axios.post(API_ENDPOINTS.SET_DEFAULT_PAYMENT_METHOD(), {
        paymentMethodId: id,
      })
      toast.success('Default card updated')
      fetchDefaultPM()
    } catch {
      toast.error('Failed to set default card')
    } finally {
      setIsActionLoading(false)
    }
  }

  const handleDelete = async (pmId) => {
    setIsActionLoading(true)

    try {
      await axios.delete(API_ENDPOINTS.DELETE_PAYMENT_METHOD(), {
        data: {paymentMethodId: pmId},
      })
      toast.success('Card deleted')
      fetchCards()
      fetchDefaultPM()
    } catch {
      toast.error('Failed to delete card')
    } finally {
      setIsModalOpen(false)
      setIsActionLoading(false)
    }
  }

  return (
    <div className='container py-4'>
      <h3 className='mb-4'>Manage Cards</h3>

      <div className='row'>
        {cards.map((pm) => (
          <div key={pm.id} className='col-md-4 mb-4'>
            <div className='card shadow-sm p-3'>
              <div className='mb-2'>
                <strong>{pm.card.brand.toUpperCase()}</strong> **** {pm.card.last4}
              </div>
              <div className='d-flex justify-content-between small'>
                <span>
                  Expires: {pm.card.exp_month}/{pm.card.exp_year}
                </span>
              </div>
              <div className='mt-3 d-flex justify-content-between align-items-center'>
                {defaultPM === pm.id ? (
                  <span className='text-success py-2'>
                    <FaCheckCircle className='me-1' /> Default
                  </span>
                ) : (
                  <button
                    className='btn btn-outline-primary btn-sm'
                    onClick={() => handleSetDefault(pm.id)}
                    disabled={isActionLoading}
                  >
                    <FaStar className='me-1' /> Set as Default
                  </button>
                )}

                {/* Show Delete only if not default */}
                {defaultPM !== pm.id && (
                  <button
                    className='btn btn-outline-danger btn-sm py-0'
                    onClick={() => {
                      setDeleteCardId(pm?.id)
                      setIsModalOpen(true)
                    }}
                    disabled={isActionLoading}
                  >
                    <FaTrash />
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <ConfirmationModal
        isLoading={isActionLoading}
        isOpen={isModalOpen}
        title='Are you sure?'
        message='You want to delete this card?'
        confirmButtonTitle='Confirm'
        onConfirm={() => handleDelete(deleteCardId)}
        onCancel={() => setIsModalOpen(false)}
      />

      <div className='mt-4'>
        {!addingCard ? (
          <button
            className='btn btn-primary'
            onClick={() => setAddingCard(true)}
            disabled={isActionLoading}
          >
            + Add New Card
          </button>
        ) : (
          <div className='col-md-8 mt-4'>
            <Elements stripe={stripePromise}>
              <AddCardForm
                onComplete={() => {
                  setAddingCard(false)
                  fetchCards()
                }}
              />
            </Elements>
          </div>
        )}
      </div>
    </div>
  )
}
